import * as React from 'react';
import {  TextField } from '@mui/material';

export default function BasicTable() {
    return (
        <>
            <TextField id="outlined-basic" label="User Name" variant="outlined" />        </>
    );
}
